import { render, staticRenderFns } from "./msg-box-confirm.vue?vue&type=template&id=d3b38a6e&scoped=true&"
import script from "./msg-box-confirm.vue?vue&type=script&lang=js&"
export * from "./msg-box-confirm.vue?vue&type=script&lang=js&"
import style0 from "./msg-box-confirm.vue?vue&type=style&index=0&id=d3b38a6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3b38a6e",
  null
  
)

export default component.exports